import { useTranslation } from 'react-i18next';

const BucketSearchInputPlaceholder = () => {
  const [t] = useTranslation();
  return (
    <p className="text-xs u-color--DarkGray mt-1">
      {t('BUCKET_MODEL_NO_PLACEHOLDER')}
    </p>
  );
};

export default BucketSearchInputPlaceholder;
